import React, { useState, useEffect } from 'react';
import { initAssignmentSession, initFreeExerciseSessionScorableMaterial } from '../exercise-manager/util/exercises-api.js';
import ConfirmationDialog from './ConfirmationDialog.js';

function Confirmation({ id, material, tokenAccessor, onClose, onConfirm, translations, isOwner, studioGroup, }) {
    const [session, setSession] = useState(null);
    useEffect(() => {
        async function initConfirmation() {
            const token = await tokenAccessor.tokenGetter();
            const sessionData = !isOwner && material.assignment
                ? await initAssignmentSession(token, material.module, material.assignment.id, studioGroup)
                : await initFreeExerciseSessionScorableMaterial(token, material.module, material.id, studioGroup);
            // set phase to start when assignment is not started yet
            if (sessionData.resumable === false && sessionData.result === undefined) {
                return onConfirm();
            }
            // set phase to start when assignment or free exercise is started but not finished yet
            if (sessionData.resumable === true && (!('isExpired' in sessionData) || !sessionData.isExpired)) {
                return onConfirm();
            }
            setSession(sessionData);
        }
        initConfirmation();
    }, [tokenAccessor, material, onConfirm, isOwner]);
    if (session) {
        const isRepeatable = isOwner || !material.assignment || material.assignment.repeatable;
        // Will be opened by onConfirm
        if (!session.result || session.resumable === true)
            return null;
        if (isRepeatable) {
            // LTI Exercise was already made but is repeatable (because repeatable assignment/free-exercise/being owner), user gets option to restart
            return (React.createElement(ConfirmationDialog, { id: id, material: material, onConfirm: onConfirm, onClose: onClose, translations: translations, session: session, isOwner: isOwner }));
        }
        if (material.assignment && !material.assignment.repeatable) {
            // Assignment was already submitted and is not repeatable, user can not start again
            return (React.createElement(ConfirmationDialog, { id: id, material: material, onConfirm: onConfirm, onClose: onClose, translations: translations, session: session, isOwner: isOwner }));
        }
    }
    return null;
}

export { Confirmation as default };
